"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const b_1 = __importDefault(require("b_"));
const tooltip_styles_1 = __importDefault(require("./tooltip.styles"));
const b = b_1.default.with('tooltip');
function Tooltip({ children, text, onlyMobile, checked }) {
    const isMobile = window.innerWidth <= 768;
    const shouldDisplay = (onlyMobile ? isMobile : true) && text !== '';
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: tooltip_styles_1.default }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('wrapper', { showPopup: checked }) }, { children: [children, shouldDisplay && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('text') }, { children: text }))] })) })));
}
exports.default = Tooltip;
